import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography, Button, ClickAwayListener, Popover, TextField } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { experimentalStyled as styled } from "@mui/material/styles";
import { getIssueTypeIcon, getPriorityIcon } from '../../utilities/Icons';
import { Tooltip } from "@mui/material";
import { taskTypesList } from '../../utilities/Json';
import BackgroundLetterAvatarsLogo from '../AvatarLogo';
import { Textarea } from '@mui/joy';
import IssueTypeMenuList from '../../common/IssueTypeMenuList';
import { FiPlus } from "react-icons/fi";
import { IssueStatusCardSkeleton, NormalSkeleton, CircularSkeleton } from '../../common/Skeleton';
import SearchableDropdown from '../Modal/SearchableDropDown';
import IconButton from "@mui/material/IconButton";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { getLastFiveActiveSprintInfo, getSprintsList, SetlastfiveActiveSprintInfo, updateIssue } from '../../common/Redux/Reducer';
import useDropHighlight from '../../common/useDropHighlight';

// Enhanced Loading Component
const EnhancedLoader = ({ size = 'medium', text = 'Loading...', variant = 'spinner' }) => {
  const sizeMap = {
    small: { width: '16px', height: '16px', fontSize: '11px' },
    medium: { width: '24px', height: '24px', fontSize: '13px' },
    large: { width: '32px', height: '32px', fontSize: '14px' }
  };

  const currentSize = sizeMap[size];

  if (variant === 'dots') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center'
          }}
        >
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#1976d2',
                animation: 'dotPulse 1.4s ease-in-out infinite both',
                animationDelay: `${index * 0.16}s`,
                '@keyframes dotPulse': {
                  '0%, 80%, 100%': {
                    transform: 'scale(0.8)',
                    opacity: 0.5
                  },
                  '40%': {
                    transform: 'scale(1)',
                    opacity: 1
                  }
                }
              }}
            />
          ))}
        </Box>
        <Typography 
          sx={{ 
            fontSize: currentSize.fontSize, 
            color: '#555',
            fontWeight: '500',
            textAlign: 'center'
          }}
        >
          {text}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5
      }}
    >
      <Box
        sx={{
          width: currentSize.width,
          height: currentSize.height,
          borderRadius: '50%',
          background: 'conic-gradient(from 0deg, #1976d2, #42a5f5, #1976d2)',
          animation: 'spin 1s linear infinite',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '2px',
            left: '2px',
            right: '2px',
            bottom: '2px',
            backgroundColor: 'white',
            borderRadius: '50%'
          },
          '@keyframes spin': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' }
          }
        }}
      />
      <Typography 
        sx={{ 
          fontSize: currentSize.fontSize, 
          color: '#555',
          fontWeight: '500',
          textAlign: 'center'
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};



const EachTask = styled(Paper)(({ theme }) => ({
    backgroundColor: '#F7F8FB',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'start',
    color: theme.palette.text.secondary,
    minHeight: '150px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    border: '1px solid #EFF1F6',
    borderRadius: '14px',
    // minWidth: '238px',
    width: '100%'

}));

const ActiveSprintAssigneesLayout = ({
    searchTerm = '', 
    activeSprintId = '',
    issueStatusList = [],
    handleCreateIssueClick = () => { },
    isEditing = false,
    currentTaskIndex = 0,
    issueType = "Task",
    setIssueType = () => { },
    handleChangeIssueTitle = () => { },
    handleClickAway = () => { },
    handleTextareaSubmit = () => { },
    onChangeModalStatus = () => { },
    draggedTodoItem = {},
    selectedIssueType = '',
    selectPriorityType = '',
    newTaskTitle = '',
    handleSaveClick,
    handleSaveIssue = () => { },
    handleCancelIssue = () => { },
    handleEditClick = () => { },
    handleDeleteTaskStatus = () => { },
    editingTaskIndex = '',
    setNewTaskTitle = () => { },
    showInput = '',
    handleAddTaskItem = () => { },
    inputValue = '',
    setInputValue = () => { },
    handleCancelClick = () => { },
    inputRef = '',
    // New props for assignee functionality
    assigneeUpdating = null,
    handleAssigneeUpdate = () => { },
    handlePopOverClick = () => { },
    handlePopOverClose = () => { },
    anchorEl = { id: "", element: null },
    contributors = []
}) => {

    const { Projects, assignees, Skeleton, assigneeLayoutSkeleton } = useSelector((state) => {
        return state.ProjamAppSlice;
    });

    /* which column the pointer is over right now, so the board can show it */
    const { activeZone, getZoneProps, clearZone } = useDropHighlight();

    const SprintData = Projects?.selectedProject?.activeSprintAssigneesLayoutData
    const userDetails = Projects?.selectedProject?.loggedUserDetails
    let backlogId = Projects?.selectedProject?.selectedProjectBackLogId
    const filterAssigneesArray = useSelector((state) => state.ProjamAppSlice.assignee)
    let projectId = Projects?.selectedProject?.selectedProjectData?._id

    const [data, setData] = useState(SprintData?.AssigneGroupObj || [])

    // console.log(data , 'data')
    const [Employee, setEmployee] = useState('');
   

    const dispatch = useDispatch()
    const activeSprint = Projects?.selectedProject?.ActiveSprint;

    const [issueCountObj , setIssueCountObj]=useState(activeSprint?.IssuecountObj||{})

    useEffect(() => {
        if (SprintData?.AssigneGroupObj?.length > 0) {
            if (assignees && assignees?.length > 0) {
                let filteredAssigneesData = SprintData?.AssigneGroupObj?.filter((eachEmployee) =>
                    (assignees?.includes(eachEmployee?.employeeDetails?.employeeName|| eachEmployee?.employeeDetails?.employeeEmail) || eachEmployee?.employeeDetails?.employeeName === "Unassigned")
                );

                // Filter issues based on searchTerm
                filteredAssigneesData = filteredAssigneesData?.map((eachEmployee) => {
                    return {
                        ...eachEmployee,
                        assignedIssues: eachEmployee?.assignedIssues?.filter((eachIssue) =>
                            eachIssue?.summary?.toLowerCase().includes(searchTerm.toLowerCase())
                        )
                    };
                });
                console.log(filteredAssigneesData , 'filteredAssigneesData')
                if (selectedIssueType) {
                    const fitleredIssueTypeData = filteredAssigneesData?.map((eachEmployee) => {
                        return {
                            ...eachEmployee,
                            assignedIssues: eachEmployee?.assignedIssues?.filter((eachIssue) => eachIssue?.issueType?.toLowerCase() === selectedIssueType?.toLowerCase())
                        }
                    });
                    setData(fitleredIssueTypeData)
                }
                if (selectPriorityType) {
                    const fitleredIssueTypeData = filteredAssigneesData?.map((eachEmployee) => {
                        return {
                            ...eachEmployee,
                            assignedIssues: eachEmployee?.assignedIssues?.filter((eachIssue) => eachIssue?.priority?.toLowerCase() === selectedIssueType?.toLowerCase())
                        }
                    });
                    setData(fitleredIssueTypeData)
                }

                else {
                    console.log('Filtered Assignees Data:', filteredAssigneesData);
                    setData(filteredAssigneesData)
                }
            } else {
                if (selectedIssueType) {
                    const fitleredIssueTypeData = SprintData?.AssigneGroupObj?.map((eachEmployee) => {
                        return {
                            ...eachEmployee,
                            assignedIssues: eachEmployee?.assignedIssues?.filter((eachIssue) => eachIssue?.issueType?.toLowerCase() === selectedIssueType?.toLowerCase())
                        }
                    })
                    setData(fitleredIssueTypeData);
                } else {
                    setData(SprintData?.AssigneGroupObj)
                }
            }
        }
    }, [assignees, selectedIssueType, SprintData, searchTerm, selectPriorityType]);

    const getUpdatedBurnDownInfo = async () => {
        try {
          let response = await dispatch(getLastFiveActiveSprintInfo({ backlogId, projectId }));
          dispatch(SetlastfiveActiveSprintInfo(response?.payload))
    
        }
        catch (error) {
          console.log(error)
        }
      }

    /* Each assignee row repeats the status columns, so a drop zone is keyed by
       both the person and the status. */
    const dropZoneId = (employee, statusTitle) =>
        `${employee?.employeeDetails?.employeeId || employee?.employeeDetails?.employeeEmail || 'unassigned'}-${statusTitle}`;

    /* Green when the hovered column would actually move the card, neutral when
       it is the column the card already sits in. */
    const dropStateClass = (employee, statusTitle) => {
        const dragged = draggedTodoItem?.current;
        if (!dragged || activeZone !== dropZoneId(employee, statusTitle)) return '';
        return dragged?.status?.toLowerCase() === statusTitle?.toLowerCase()
            ? 'is-drop-origin'
            : 'is-drop-target';
    };

    const handleColumnDrop = async (status = '', draggedItemType) => {
        const dragged = draggedTodoItem?.current;

        if (!dragged || draggedItemType !== dragged?.draggedItemType) {
            draggedTodoItem.current = null;
            return;
        }

        let customArray = [...data];
        let reqAssignee = customArray.find((each) =>
            each.assignedIssues.find((issue) => issue._id == dragged?.id)
        );

        if (!reqAssignee) {
            draggedTodoItem.current = null;
            return;
        }

        let reqIssue = reqAssignee.assignedIssues.find((issue) =>
            issue._id == dragged?.id
        );

        const sts = reqIssue?.status;

        /* dropped back into the same status lane — the board is unchanged, so
           the counts must stay untouched */
        if (!reqIssue || sts?.toLowerCase() === status?.toLowerCase()) {
            draggedTodoItem.current = null;
            return;
        }

        /* only a real lane-to-lane move touches the counts */
        const countOf = (title) => Number(issueCountObj?.[title]) || 0;
        const dummyIssueCountObj = {
            ...issueCountObj,
            [status]: countOf(status) + 1,
            [sts]: Math.max(0, countOf(sts) - 1),
        };

        reqIssue = { ...reqIssue, status };

        let indexOfAssigneeObj = customArray.findIndex((eachAssignee) => 
            eachAssignee.employeeDetails.employeeId == reqAssignee.employeeDetails.employeeId
        );

        
        let updatedAssignedIssues = [...customArray[indexOfAssigneeObj].assignedIssues];
        let indexOfIssue = updatedAssignedIssues.findIndex((issue) => 
            issue._id == dragged?.id
        );

        updatedAssignedIssues[indexOfIssue] = reqIssue;

       
        customArray[indexOfAssigneeObj] = {
            ...customArray[indexOfAssigneeObj],
            assignedIssues: updatedAssignedIssues,
        };

        setData(customArray); 
        setIssueCountObj(dummyIssueCountObj)

        draggedTodoItem.current = null;

        await dispatch(updateIssue({ issueId: dragged?.id, payload: { status } }));
        await dispatch(getSprintsList({ backlogId, filterAssigneesArray }));
        getUpdatedBurnDownInfo();
    };

    const userAccess = (userDetails.role === 'Project Manager' || userDetails.role === 'Project Lead' || userDetails.role === 'Scrum Master' || userDetails.role === 'Project Owner') ? true : false

    return (
        <div className='my-3 px-3'>
            <Grid container spacing={1} className="assignee-status-header" sx={{ flexWrap: 'nowrap', marginBottom: "10px" }} >
                {issueStatusList?.map((eachTask, index) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={2} key={eachTask.title} sx={{ flexShrink: 0 }}>
                            <Box key={eachTask?.title} sx={{}} >
                                {!Skeleton ? (
                                    <div className="status-column-head">
                                        {userAccess && isEditing && editingTaskIndex === index ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: '2px' }}>
                                                <TextField
                                                    value={newTaskTitle}
                                                    onChange={(e) => setNewTaskTitle(e.target.value)}
                                                    autoFocus
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{ flexGrow: 1 }}
                                                />
                                                <IconButton color="primary" size="small" onClick={() => handleSaveIssue(index, eachTask._id)}>
                                                    <CheckIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton color="secondary" size="small" onClick={handleCancelIssue}>
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        ) : (
                                            <>
                                                <span className="each-task-status-title-cls">
                                                    {eachTask?.title}
                                                </span>
                                                <span className="each-tasks-cls">
                                                    {issueCountObj?.[eachTask?.title] || 0}
                                                </span>
                                                {userAccess && !isEditing && issueCountObj?.[eachTask?.title] == 0 && (
                                                    <span className="status-column-actions">
                                                        <EditIcon
                                                            className="edit-icon task-status-icon"
                                                            onClick={() => handleEditClick(index, eachTask?.title)}
                                                        />
                                                        <DeleteIcon
                                                            className="delete-icon task-status-icon"
                                                            onClick={() => handleDeleteTaskStatus(eachTask?._id)}
                                                        />
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <IssueStatusCardSkeleton isStatus={true} />
                                )}
                            </Box>
                        </Grid>)
                })
                }
                {userAccess && <div className="d-flex flex-column  justify-content-start">
                    {!showInput ? (
                        issueStatusList?.length < 8 && (
                            <Box
                                sx={{
                                    minWidth: 100,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: '10px'
                                }}
                            >
                                <IconButton color="primary" className="add-status-btn" onClick={handleAddTaskItem}>
                                    <FiPlus />
                                </IconButton>
                            </Box>
                        )
                    ) : (
                        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 100, marginLeft: '8px', marginTop: '8px' }} >
                            <TextField
                                variant="outlined"
                                size="small"
                                className="add-status-input"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                fullWidth
                                onFocus={() => inputRef.current?.focus()}
                                sx={{ width: '150px' }}
                            />
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-end',
                                mt: 0
                            }}>
                                <IconButton color="primary" onClick={handleSaveClick}>
                                    <CheckIcon />
                                </IconButton>
                                <IconButton color="secondary" onClick={handleCancelClick}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    )}
                </div>}

            </Grid>
            {data?.map((eachEmployee, index) =>
                eachEmployee?.assignedIssues?.length > 0 || eachEmployee?.employeeDetails?.employeeName === "unassigned" ? <Box
                    sx={{ flexGrow: 1 }}
                    className=" my-0"
                    key={`${eachEmployee?.employeeDetails?.employeeId}-${index}`}
                >
                    {(!Skeleton && !assigneeLayoutSkeleton) ? <Accordion
                        defaultExpanded={true}
                        className="issues-accordian-main-cls"
                    >
                        <div className="d-flex align-items-center">
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ fontSize: '1.3 rem !important' }} />}
                                aria-controls={`panel1-content-${eachEmployee?.employeeDetails?.employeeId}`}
                                id={`panel1-header-${eachEmployee?.employeeDetails?.employeeId}`}
                                className="issues-accordian-summary-cls"
                            >
                                <div className='d-flex align-items-center'>
                                    <BackgroundLetterAvatarsLogo LogoTitle={eachEmployee?.employeeDetails?.employeeName ||eachEmployee?.employeeDetails?.employeeEmail } RequiredFontSize='10px !important' extraIdName="assignee-layout-avatar-cls" />
                                    <Typography sx={{ fontSize: "14px" }}>
                                        <b className="me-1">{eachEmployee?.employeeDetails?.employeeName ||eachEmployee?.employeeDetails?.employeeEmail}</b>
                                        ({eachEmployee?.assignedIssues?.length === 1 ? `${eachEmployee?.assignedIssues?.length} issue` : `${eachEmployee?.assignedIssues?.length} issues`})
                                    </Typography>
                                </div>
                            </AccordionSummary>
                        </div>
                        <AccordionDetails className="px-0">
                            <Grid
                                container
                                spacing={1}
                                alignItems="stretch"
                                flexWrap={'nowrap'}
                            >

                                {issueStatusList?.map((eachTask, index) => (

                                    <Grid item xs={12} sm={6} md={4} lg={2} key={eachTask.title} sx={{ flexShrink: 0 }}>
                                        <EachTask
                                            className={`shadow-none p-1 task-card-hover-cls status-column-body ${dropStateClass(eachEmployee, eachTask?.title)}`}
                                            {...getZoneProps(dropZoneId(eachEmployee, eachTask?.title))}
                                            onDrop={(e) => {
                                                clearZone();
                                                handleColumnDrop(
                                                    eachTask.title, "issue"
                                                );
                                            }}
                                        >
                                            {eachEmployee?.assignedIssues?.map((eachIssue, index) =>
                                                eachTask?.title?.toLowerCase() ===
                                                    eachIssue?.status?.toLowerCase() ? (
                                                    <Box
                                                        key={eachIssue?._id}
                                                        className="d-flex flex-column justify-content-between task-item sprint-issue-card mb-1"
                                                        draggable
                                                        onDragStart={(e) =>
                                                            (draggedTodoItem.current = { id: eachIssue?._id, status: eachIssue?.status, draggedItemType: 'issue' })
                                                        }
                                                        onDragEnd={clearZone}
                                                        onDragOver={(e) => e.preventDefault()}
                                                    >
                                                        <div className='d-flex align-items-center'>
                                                            <Tooltip
                                                                title={eachIssue?.issueType || "Story"}
                                                            >
                                                                {getIssueTypeIcon(eachIssue?.issueType)}
                                                            </Tooltip>
                                                            <p className='ms-1 mb-0 issue-para-name-cls'>{eachIssue?.name}</p>
                                                        </div>

                                                        <Typography
                                                            className="task-title"
                                                            onClick={() =>
                                                                onChangeModalStatus(eachIssue)
                                                            }
                                                        >
                                                            {eachIssue?.summary}
                                                        </Typography>
                                                        <div
                                                            className="d-flex justify-content-between align-items-center mt-2"
                                                            style={{ width: "100%" }}
                                                        >
                                                            <div className="d-flex align-items-center" style={{ margin: "0px", flexGrow: 1 }}>
                                                                <Tooltip title={"Story point"}>
                                                                    <span className="badge rounded-pill">
                                                                        <Button className="StoryPoint_badge">
                                                                        {eachIssue?.storyPointEstimate}
                                                                        </Button>
                                                                    </span>
                                                                </Tooltip>
                                                            </div>
                                                            <div style={{ flex: 2, justifyContent: 'center' }}>
                                                                <Tooltip
                                                                    title={eachIssue?.priority || "Urgent"}
                                                                >
                                                                    {getPriorityIcon(eachIssue?.priority)}
                                                                </Tooltip>
                                                            </div>
                                                            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Button 
                                                                    size="small"
                                                                    className="assingeeBtnDropdown_main"
                                                                    aria-describedby={eachIssue?._id}
                                                                    onClick={(event) => handlePopOverClick(event, eachIssue?._id)}
                                                                    disabled={assigneeUpdating === eachIssue?._id}
                                                                    sx={{
                                                                        position: 'relative',
                                                                        opacity: assigneeUpdating === eachIssue?._id ? 0.7 : 1
                                                                    }}
                                                                >
                                                                    {assigneeUpdating === eachIssue?._id && (
                                                                        <Box
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                top: '50%',
                                                                                left: '50%',
                                                                                transform: 'translate(-50%, -50%)',
                                                                                zIndex: 10
                                                                            }}
                                                                        >
                                                                            <EnhancedLoader size="small" text="" />
                                                                        </Box>
                                                                    )}
                                                                    <Box sx={{ opacity: assigneeUpdating === eachIssue?._id ? 0 : 1 }}>
                                                                        <BackgroundLetterAvatarsLogo 
                                                                            LogoTitle={eachEmployee?.employeeDetails?.employeeName !== "Unassigned" ? eachEmployee?.employeeDetails?.employeeName || eachEmployee?.employeeDetails?.employeeEmail : ''} 
                                                                            RequiredFontSize='8px !important' 
                                                                            extraIdName="assignee-layout-issue-card-avatar-cls" 
                                                                        />
                                                                    </Box>
                                                                </Button>
                                                                <Popover
                                                                    id={eachIssue?._id}
                                                                    open={anchorEl?.id === eachIssue?._id}
                                                                    anchorEl={anchorEl?.element}
                                                                    onClose={assigneeUpdating === eachIssue?._id ? undefined : handlePopOverClose}
                                                                    disableEscapeKeyDown={assigneeUpdating === eachIssue?._id}
                                                                    anchorOrigin={{
                                                                        vertical: "bottom",
                                                                        horizontal: "left",
                                                                    }}
                                                                    PaperProps={{
                                                                        sx: {
                                                                            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                                                                            borderRadius: '15px',
                                                                            padding: 1,
                                                                            width: 280,
                                                                            maxHeight: '320px',
                                                                            overflow: 'hidden',
                                                                            border: '1px solid rgba(0, 0, 0, 0.05)',
                                                                        },
                                                                    }}
                                                                >
                                                                    <Box sx={{ 
                                                                        position: 'relative',
                                                                        minHeight: '60px',
                                                                    }}>
                                                                        {assigneeUpdating === eachIssue?._id && (
                                                                            <Box
                                                                                sx={{
                                                                                    position: 'absolute',
                                                                                    top: 0,
                                                                                    left: 0,
                                                                                    right: 0,
                                                                                    bottom: 0,
                                                                                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    zIndex: 1000,
                                                                                    borderRadius: '8px',
                                                                                    backdropFilter: 'blur(2px)'
                                                                                }}
                                                                            >
                                                                                <EnhancedLoader 
                                                                                    size="medium" 
                                                                                    text="Updating assignee..." 
                                                                                    variant="dots"
                                                                                />
                                                                            </Box>
                                                                        )}
                                                                        <Box sx={{
                                                                            opacity: assigneeUpdating === eachIssue?._id ? 0.3 : 1,
                                                                            pointerEvents: assigneeUpdating === eachIssue?._id ? 'none' : 'auto',
                                                                            transition: 'opacity 0.2s ease'
                                                                        }}>
                                                                            <SearchableDropdown
                                                                                workFlowModalTaskData={eachIssue}
                                                                                members={contributors}
                                                                                handleAssigneeUpdate={handleAssigneeUpdate}
                                                                            />
                                                                        </Box>
                                                                    </Box>
                                                                </Popover>
                                                            </div>
                                                        </div>
                                                    </Box>
                                                ) : null
                                            )}
                                            {index === currentTaskIndex && isEditing && Employee?.employeeId === eachEmployee?.employeeDetails?.employeeId ? (
                                                <ClickAwayListener onClickAway={handleClickAway}>
                                                    {/* same composer card as the status board, sized to the lane */}
                                                    <Box
                                                        component="form"
                                                        className="sprint-inline-composer"
                                                        onSubmit={(event) => {
                                                            if (eachEmployee?.employeeDetails?.employeeName === "unassigned") {
                                                                handleTextareaSubmit(event, eachTask.title, [])
                                                            } else {
                                                                handleTextareaSubmit(event, eachTask.title, eachEmployee?.employeeDetails)
                                                            }
                                                        }}
                                                    >
                                                        <Textarea
                                                            variant="plain"
                                                            placeholder="What needs to be done?"
                                                            className="sprint-grid-layout-create-issue-input"
                                                            minRows={2}
                                                            maxRows={6}
                                                            autoFocus
                                                            onChange={handleChangeIssueTitle}
                                                        />
                                                        <div className="sprint-inline-composer__footer">
                                                            <div className="sprint-inline-composer__meta">
                                                                <IssueTypeMenuList
                                                                    labelText="Issue type"
                                                                    ItemsList={taskTypesList}
                                                                    setSelectedValue={setIssueType}
                                                                    selectedValue={issueType}
                                                                    isActiveSprintPage={true}
                                                                />
                                                            </div>
                                                            <Button
                                                                type="submit"
                                                                size="small"
                                                                variant="contained"
                                                                color="success"
                                                                className="sprint-grid-layout-create-issue-btn"
                                                            >
                                                                Create
                                                            </Button>
                                                        </div>
                                                    </Box>
                                                </ClickAwayListener>
                                            ) : (
                                                <button
                                                    onClick={() => {
                                                        setEmployee(eachEmployee?.employeeDetails)
                                                        handleCreateIssueClick(index)

                                                    }}
                                                    className={` active-sprints-create-issue-btn-cls py-2`}
                                                >
                                                    <FiPlus className="me-1" />
                                                    Create Issue
                                                </button>
                                            )}
                                        </EachTask>
                                    </Grid>))}
                            </Grid>
                        </AccordionDetails>
                    </Accordion> :
                        <div>
                            <div className='d-flex align-items-center my-2'>
                                <CircularSkeleton />
                                <NormalSkeleton width='200px' extraStyles=" ms-2" />
                            </div>
                            <Grid
                                container
                                spacing={{ xs: 2, md: 1 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                justifyContent="space-between"
                                alignItems="stretch"
                            >
                                {issueStatusList?.map((eachTask, index) => (
                                    <Grid item xs={2} sm={2} md={2} key={eachTask.title}>
                                        <EachTask
                                            className="shadow-none p-1 task-card-hover-cls status-column-body">
                                            <IssueStatusCardSkeleton />
                                        </EachTask>
                                    </Grid>))}
                            </Grid>
                        </div>}

                </Box> : null
            )}

        </div>
    )
}

export default ActiveSprintAssigneesLayout